import React from 'react';
import { motion } from 'framer-motion';

const Loader = () => {
    return (
        <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: 0, pointerEvents: 'none' }}
            transition={{ duration: 1, delay: 2 }}
            className="fixed inset-0 z-[1000] bg-[#f9fcfd] flex items-center justify-center flex-col px-6"
        >
            <div className="relative">
                <motion.div
                    initial={{ scale: 0, rotate: 0 }}
                    animate={{ scale: [0, 1, 1, 0], rotate: [0, 0, 180, 180] }}
                    transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                    className="w-24 h-24 border-4 border-brand-teal rounded-3xl"
                />
<div className="absolute inset-0 flex items-center justify-center">
    <img
        src="/images/Codebytz.png"
        alt="Codebytz Logo"
        className="w-20 h-20 object-contain"
    />
</div>
            </div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                className="mt-12 flex flex-col items-center gap-4"
            >
                <span className="text-2xl font-bold tracking-tighter text-Black">
                    CODE<span className="text-brand-teal">BYTZ</span>
                </span>
                <div className="w-48 h-1 bg-white/10 rounded-full overflow-hidden">
                    <motion.div
                        initial={{ x: '-100%' }}
                        animate={{ x: '100%' }}
                        transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
                        className="w-full h-full bg-brand-teal"
                    />
                </div>
                <p className="text-xs text-gray-500 uppercase tracking-[0.4em] mt-2">Loading Innovation</p>
            </motion.div>
        </motion.div>
    );
};

export default Loader;
